/**
 * Cross-cutting chrome primitives shared by page / header / map / media shells.
 * Position and feature-specific modifiers stay on the consuming shell.
 *
 * Roles:
 * - iconClose: fixed dismiss hit target (add absolute/ml-* at call site)
 * - navHit / navIcon / navLabel: header nav affordance (fixed height; width follows label)
 * - scrollThin: thin scrollbar styling for panels
 * - filterBadge: compact count badge on filter triggers
 */

import { typeShell } from "./typeShell";

export const chromeShell = {
    iconClose:
        "flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-1 text-text-primary shadow-none transition-colors hover:text-text-secondary",

    navHit:
        "group box-border flex h-10 min-w-12 cursor-pointer flex-col items-center justify-center gap-0.5 rounded px-1 transition-colors duration-300",

    navIcon:
        "text-icon-control leading-none no-underline transition-colors duration-300",

    navLabel:
        `max-w-full overflow-hidden text-ellipsis whitespace-nowrap no-underline transition-colors duration-300 ${typeShell.navLabel}`,

    scrollThin:
        "[scrollbar-color:var(--ui-muted)_var(--surface-muted)] [scrollbar-width:thin] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb]:bg-ui-muted hover:[&::-webkit-scrollbar-thumb]:bg-text-hint [&::-webkit-scrollbar-track]:rounded [&::-webkit-scrollbar-track]:bg-surface-muted",

    filterBadge:
        `inline-flex h-5 min-w-6 shrink-0 items-center justify-center rounded-xl px-1.5 ${typeShell.badge}`,
};
